import { render, staticRenderFns } from "./AssinaturaPad.vue?vue&type=template&id=8f7e2bea&"
import script from "./AssinaturaPad.vue?vue&type=script&lang=js&"
export * from "./AssinaturaPad.vue?vue&type=script&lang=js&"
import style0 from "./AssinaturaPad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports